











































import { OWebSignUp } from "oweb";
import BaseComponent from "@/components/BaseComponent.vue";
import app from "@/app";
import { Component } from "vue-property-decorator";

@Component
export default class WUserSignupThree extends BaseComponent {
	form = getForm();

	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			sign_up = new OWebSignUp(app);

		sign_up
			.onError(function(response) {
				app.view.dialog(response);
			})
			.onSuccess(function(response) {
				app.user.setCurrentUser(response.data);

				app.router.forceNextReplace().browseTo("/");
			})
			.stepEnd(form);
	}
}

const getForm = function() {
	return {
		fields: {
			uname: {
				field: "input",
				label: { i18n: "OO_LANG_USER_NAME" },
				attrs: { name: "uname", type: "text" }
			},
			email: {
				field: "input",
				label: { i18n: "OO_LANG_EMAIL" },
				attrs: { name: "email", type: "text" }
			},
			birth_date: {
				field: "input",
				label: { i18n: "OO_LANG_BIRTH_DATE" },
				attrs: { name: "birth_date", type: "date" }
			},
			gender: {
				field: "select",
				label: { i18n: "OO_LANG_SEX" },
				attrs: { name: "gender" },
				options: [
					{
						attrs: {
							value: "Male",
							selected: ""
						},
						i18n: "OO_LANG_MALE"
					},
					{
						attrs: {
							value: "Female",
							selected: ""
						},
						i18n: "OO_LANG_FEMALE"
					}
				]
			},
			pass: {
				field: "input",
				label: { i18n: "OO_LANG_PASSWORD" },
				attrs: { name: "pass", type: "password" }
			},
			vpass: {
				field: "input",
				label: { i18n: "OO_LANG_CONFIRM_PASSWORD" },
				attrs: { name: "vpass", type: "password" }
			},
			cgu_agree_checkbox: {
				field: "cgu",
				label: { i18n: "OO_LANG_ACCEPT_CGU" },
				attrs: { name: "oweb_signup_cgu_agree_checkbox" }
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_VALIDATE_BTN"
			}
		}
	};
};
